"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var ProfileImage_1 = __importDefault(require("./ProfileImage"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LevelUpModal = function () {
    var _a;
    var currentLevelInfo = (0, swr_hooks_1.usePlayerStatus)().currentLevelInfo;
    var prizes = (0, swr_hooks_1.usePrizesByLevel)(currentLevelInfo);
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var onClose = (0, react_1.useCallback)(function () {
        closeModal();
    }, [closeModal]);
    if (!isAuth)
        return null;
    return (react_1.default.createElement(ui_components_1.Modal, { width: "450px", height: "auto", padding: "0", onClose: onClose },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.background }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('levelUp')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.subTitle }, t('levelUpCongratulations')),
            react_1.default.createElement(ProfileImage_1.default, { imageUrl: (_a = currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.images) === null || _a === void 0 ? void 0 : _a.big }),
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.levelTitle, " ").concat(styles_module_scss_1.default['level' + (currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level)]) }, currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.name),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.levelNumber },
                "Level ", currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 :
                currentLevelInfo.level),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.prizes }, prizes.map(function (prize, i) { return (react_1.default.createElement("div", { key: "prize_modal_".concat(i) },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prize }, prize.value),
                prize.title && (react_1.default.createElement("div", { className: styles_module_scss_1.default.prizeTitle }, prize.title)))); })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", minWidth: "200px", maxWidth: "320px", width: "100%", onClick: onClose }, t('ok'))))));
};
exports.default = LevelUpModal;
